module.exports = __webpack_public_path__ + "static/img/home_v3.7ee78dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TopBar/home_v3.svg
// module id = yv+h
// module chunks = 0